module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112822-CreativeAnalysis-GMC-Modern-Round.1549dfff.jpeg";